class EmployeeEditForm {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el

    this.$root.on('change', '.employees__form-role', this.roleChanged.bind(this))
    this.$root.on('click', '.js-toggle-all', this.toggleAll.bind(this))
    this.$root.on(
      'change',
      '.employee-form__feature input[type="checkbox"]',
      this.refreshToggles.bind(this),
    )
    this.roleChanged()
  }

  roleChanged() {
    const currentRole = this.$root.find('.js-employee-role:checked').val()

    // admins do anything, so hide the features/countries select
    this.$root
      .find('.js-countries-group, .js-scopes-group')
      .toggle(currentRole !== 'admin' && currentRole !== 'super_admin')

    this.$root
      .find('.js-features-group .employee-form__feature, .js-scopes-group .employee-form__scope')
      .each((_, el) => {
        const $el = $(el)
        const matchesRole = ($el.data('roles') || '').indexOf(currentRole) !== -1

        $el.toggle(matchesRole)
      })

    this.refreshToggles()
  }

  toggleAll(event) {
    const $boxes = this.toggleableBoxes($(event.currentTarget))

    $boxes.prop('checked', $boxes.not(':checked').length > 0)
    this.refreshToggles()
  }

  refreshToggles() {
    this.$root.find('.js-toggle-all').each((_, el) => {
      const $toggle = $(el)
      const $boxes = this.toggleableBoxes($toggle)
      const allChecked = $boxes.length > 0 && $boxes.not(':checked').length === 0

      $toggle.text(allChecked ? 'Deselect all' : 'Select all')
    })
  }

  toggleableBoxes($toggle) {
    return $toggle
      .closest('.form__group')
      .find('.employee-form__feature:visible input[type="checkbox"]')
      .not(':disabled')
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new EmployeeEditForm($('.employees__form'))
})
